import React, { useState } from "react"; // Import React
import { FormattedMessage } from "react-intl"; // Import FormattedMessage
import "./PushButtonFilter.css";

const PushButtonFilter = (props: any) => {
  const [isFilterActive, setIsFilterActive] = useState(
    props.StateFilter !== undefined && props.StateFilter !== null
      ? props.StateFilter
      : false
  );

  const onClickFilter = () => {
    try {
      setIsFilterActive(
        props.StateFilter !== undefined && props.StateFilter !== null
          ? props.StateFilter
          : !isFilterActive
      );

      if (props.ClickSuscribe)
        props.ClickSuscribe(
          props.StateFilter !== undefined && props.StateFilter !== null
            ? props.StateFilter
            : !isFilterActive
        );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={
          ((
            props.StateFilter !== undefined && props.StateFilter !== null
              ? props.StateFilter
              : isFilterActive
          )
            ? "push-btn-filter active"
            : "push-btn-filter") + " text-center d-block"
        }
        onClick={() => onClickFilter()}
      >
        <span>
          {React.isValidElement(props.title) ? props.title : `${props.title}`} (
          {props.quantity})
        </span>
      </div>
    </>
  );
};

export default PushButtonFilter;
